import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { APP_STATE } from 'services/Define';
import MDBox from 'components/MDBox';
import Navbar from 'examples/Navbars/NavBar';
import { Grid, Card, Backdrop, CircularProgress, Menu, MenuItem, TableCell } from '@mui/material';
import * as Func from 'services/Function';
import { FetchData } from 'services/Request';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import TableHeader from 'components/Table/TableHeader';
import MDInput from 'components/MDInput';
import InputAdornment from '@mui/material/InputAdornment';
import Icon from '@mui/material/Icon';
import Pagination from '@mui/material/Pagination';
import MDButton from 'components/MDButton';

const initFind = {
  order_by: 'vp.barcode',
  order_sort: 'desc',
  page: 1,
  perPage: 10,
  branch: '',
};

function RpBranchBalance() {
  const mod = 'rp_branch_balance';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [find, setFind] = useState(initFind);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(null);
  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);
  const [cboBranch, setCboBranch] = useState([]);
  const [urlExcel, setUrlExcel] = useState('');
  const [excelLoading, setExcelLoading] = useState(false);

  const initHeader = [
    { id: 'barcode', label: 'รหัสสินค้า', align: 'center' },
    { id: 'product_name', label: 'รายการสินค้า', align: 'center' },
    { id: 'unit_name', label: 'หน่วยนับ', align: 'center' },
    { id: 'quantity_balance', label: 'คงเหลือ', align: 'center' },
    { id: 'branch_id', label: 'รหัสสาขา', align: 'center' },
  ];

  // ฟังก์ชันดึงข้อมูล (view)
  const view = (data) => {
    if (!data.branch) return;
    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();
    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang || 'th',
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      branch: data.branch,
    }).then((result) => {
      if (result.status === 'ok') {
        setRecord(result.data);
        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      lang: app.lang || 'th',
    }).then((result) => {
      if (result.status === 'ok') {
        setCboBranch(result.branch || []);
        setUrlExcel(result.excel);
        setFind((prev) => ({ ...prev, branch: result.branch_id || '' }));
        view({ ...find, branch: result.branch_id || '' });
      }
    });
  };

  const excel = () => {
    setExcelLoading(true);
    const params = new URLSearchParams();
    params.append('branch', find.branch);
    params.append('orderby', find.order_by);
    params.append('ordersort', find.order_sort);
    params.append('page', find.page);
    params.append('per_page', find.perPage);

    const url = `${urlExcel}/download?${params.toString()}`;
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;

    iframe.onload = () => {
      setExcelLoading(false);
      document.body.removeChild(iframe);
    };
    iframe.onerror = () => {
      setExcelLoading(false);
      document.body.removeChild(iframe);
    };
    document.body.appendChild(iframe);

    setTimeout(() => {
      setExcelLoading(false);
    }, 10000);
  };

  const renderLoading = () => (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
      <CircularProgress color='inherit' />
    </Backdrop>
  );

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t('element.show_record', { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t('element.show_record', { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t('element.show_record', { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = find.order_by === property && find.order_sort === 'asc';
    view({ ...find, order_by: property, order_sort: isAsc ? 'desc' : 'asc' });
  };

  const renderSearch = () => (
    <Card sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <MDInput
            select
            fullWidth
            value={find.branch}
            onChange={(e) => view({ ...find, branch: e.target.value, page: 1 })}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>{t('menu.branch')} :</InputAdornment>
              ),
            }}
          >
            {cboBranch.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </MDInput>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={1}>
          <MDBox display='flex' justifyContent='end' gap={1}>
            {find.branch ? (
              <MDButton variant='gradient' color='success' onClick={excel} disabled={excelLoading}>
                {excelLoading ? (
                  <>
                    <CircularProgress size={16} color='inherit' sx={{ mr: 1 }} />
                    Loading...
                  </>
                ) : (
                  <>
                    <Icon>table_view</Icon>&nbsp;Excel
                  </>
                )}
              </MDButton>
            ) : null}
          </MDBox>
        </Grid>
      </Grid>
    </Card>
  );

  const renderList = () => (
    <MDBox mb={7}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={2} lg={1}>
          <MDButton
            variant='contained'
            color='dark'
            size='large'
            fullWidth
            sx={{ pt: 1.6, pb: 1.6 }}
            href='/report_power_bi'
          >
            <Icon>content_paste_search</Icon>
          </MDButton>
        </Grid>
        <Grid item xs={12} sm={9} md={10} lg={11}>
          {renderSearch()}
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper} sx={{ minHeight: 400 }}>
            <Table aria-label='datatable table'>
              <TableHeader
                order={find.order_sort}
                orderBy={find.order_by}
                onRequestSort={handleSort}
                data={initHeader}
              />
              <TableBody>
                {record.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={initHeader.length} align='center'>
                      ไม่พบข้อมูลกรุณาเลือกสาขา
                    </TableCell>
                  </TableRow>
                ) : null}
                {record.map((row) => (
                  <TableRow key={row.barcode || row.id}>
                    <TableCell align='left'>{row.barcode}</TableCell>
                    <TableCell align='left'>{row.product_name}</TableCell>
                    <TableCell align='left'>{row.unit_name}</TableCell>
                    <TableCell align='center'>{Func.numberDisplay(row.quantity_balance)}</TableCell>
                    <TableCell align='center'>{row.branch_id}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12}>
          <Card sx={{ p: 2 }}>
            <MDBox display='flex' justifyContent='space-between' alignItems='flex-start'>
              <MDButton variant={show ? 'contained' : 'outlined'} color='dark' onClick={openShow}>
                {t('element.show_record', { num: find.perPage })}&nbsp;
                <Icon>keyboard_arrow_down</Icon>
              </MDButton>
              {renderShow}
              <Pagination
                count={pageTotal}
                variant='outlined'
                color='secondary'
                showFirstButton
                showLastButton
                page={pageNo || 1}
                onChange={(e, p) => view({ ...find, page: p })}
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );

  useEffect(() => {
    i18n.changeLanguage(app.lang || 'th');
    init();
    // eslint-disable-next-line
  }, []);

  return (
    <MDBox>
      <Navbar route={[t('menu.report_power_bi'), t(`menu.${mod}`)]} />
      {renderList()}
      {renderLoading()}
    </MDBox>
  );
}

export default RpBranchBalance;
